import Tab from './Tab.vue'
import TabItem from './TabItem.vue'

export {
  Tab,
  TabItem,
}



// WEBPACK FOOTER //
// ./client/components/Common/Tab/index.js